import $ from "jquery";

// Transfert de quantités d'un stock vers un autre ; les dotations des services sont atomiques.
export default {
    name: "echange-stock",
    components: {},
    props: [],
    data() {
        return {
            destination_id: null,
            articles: [],
            valeur: "",
            filtre_type: "tous",
            filtre_categorie: "",
            quantite_commune: "",
            quantite_commune_erreur: "",
            quantite_commune_en_attente: false,
            quantite_commune_timer: null,
            confirmation_quantite: false,
            proposition_quantite: null,
            confirmation_quantite_message: "",
            stock_loading: true,
            stock_error: "",
            validation_tentee: false,
            loading: false,
            message_erreur: "",
            hospital_services: [],
            services_ready: false,
            dispatch_request_key: null,
            dispatch_fingerprint: null,
        };
    },

    computed: {
        stocks() {
            return this.$store.getters["stocks"];
        },

        stock() {
            return this.$store.getters["stock"];
        },

        stock_id() {
            return this.$route.params.id;
        },

        /** Tous les stocks sauf celui de départ. */
        destinations() {
            const depart = String(this.stock_id);
            return (this.stocks || []).filter((item) => String(item.id) !== depart);
        },

        destination_service() {
            return this.hospital_services.find((service) =>
                String(service.stock_id) === String(this.destination_id) &&
                (service.is_active === true || service.is_active === 1 || service.is_active === "1")
            ) || null;
        },

        /** Articles du stock de départ (le magasin initialise `stock` à un tableau vide). */
        articles_du_stock() {
            return (this.stock && this.stock.articles) ? this.stock.articles : [];
        },

        types_disponibles() {
            const ids = [...new Set(this.articles_du_stock.map((article) => String(article.type_article_id || "autre")))];
            return ids.sort().map((id) => ({ id, label: this.libelleType(id) }));
        },

        categories_disponibles() {
            const categories = this.articles_du_stock
                .filter(article => this.filtre_type === "tous" || String(article.type_article_id || "autre") === String(this.filtre_type))
                .map(article => this.categorieArticle(article));
            return [...new Set(categories)].sort((a, b) => a.localeCompare(b, "fr"));
        },

        articles_visibles() {
            const recherche = this.normaliserRecherche(this.valeur);
            return this.articles_du_stock.filter((article) =>
                (this.filtre_type === "tous" || String(article.type_article_id || "autre") === String(this.filtre_type)) &&
                (!this.filtre_categorie || this.categorieArticle(article) === this.filtre_categorie) &&
                (!recherche || this.normaliserRecherche(this.libelleArticle(article)).includes(recherche))
            ).slice().sort((a, b) => this.libelleArticle(a).localeCompare(this.libelleArticle(b), "fr"));
        },

        articles_selectionnables_visibles() {
            return this.articles_visibles.filter((article) => Number(article.quantite) > 0);
        },

        tous_visibles_selectionnes() {
            return this.articles_selectionnables_visibles.length > 0 &&
                this.articles_selectionnables_visibles.every((article) => this.estDejaChoisi(article));
        },

        quantite_totale() {
            return this.articles.reduce((total, ligne) => {
                const nombre = Number(ligne.nombre);
                return total + (Number.isInteger(nombre) && nombre > 0 ? nombre : 0);
            }, 0);
        },

        quantites_a_ajuster() {
            return this.proposition_quantite ? this.proposition_quantite.lignes.filter(ligne => ligne.proposee < this.proposition_quantite.nombre) : [];
        },

        retour() {
            return "/stock/show/" + this.stock_id;
        },
    },

    watch: {
        filtre_type() { this.filtre_categorie = ""; },
    },

    beforeDestroy() {
        clearTimeout(this.quantite_commune_timer);
    },

    mounted() {
        setTimeout(() => {
            $(".p-content").fadeIn();
        }, 500);
        this.chargerStock();

        this.$store.dispatch("getStocks");
        this.$store.dispatch("getHospitalServices").then((response) => {
            if (!response || response.success !== true || !Array.isArray(response.data)) {
                throw new Error("Référentiel des services indisponible");
            }
            this.hospital_services = response.data;
            this.services_ready = true;
        }).catch(() => {
            this.message_erreur = "Impossible de vérifier les armoires des services. Réessayez avant tout transfert.";
        });
    },

    methods: {
        async chargerStock() {
            this.stock_loading = true;
            this.stock_error = "";
            try {
                await this.$store.dispatch("getStock", this.stock_id);
                this.articles.forEach((ligne) => {
                    const article = this.articles_du_stock.find((item) => Number(item.id) === Number(ligne.article));
                    ligne.disponible = article ? Number(article.quantite) || 0 : 0;
                });
            } catch (e) {
                this.stock_error = "Impossible de charger les quantités de la pharmacie. Réessayez.";
            } finally {
                this.stock_loading = false;
            }
        },

        libelleType(id) {
            if (String(id) === "1") return "Médicaments";
            if (String(id) === "2") return "Consommables";
            return "Autres articles";
        },

        normaliserRecherche(valeur) {
            return String(valeur || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
        },

        attributsArticle(article) {
            try {
                const attributs = typeof article.attribut === "string" ? JSON.parse(article.attribut) : article.attribut;
                return attributs && typeof attributs === "object" ? attributs : {};
            } catch (e) { return {}; }
        },

        categorieArticle(article) {
            const attributs = this.attributsArticle(article);
            const valeur = String(article.type_article_id) === "2"
                ? article.famille || attributs.Famille
                : article.categorie || attributs["Catégorie"];
            const libelle = valeur && typeof valeur === "object" ? valeur.libelle : valeur;
            return typeof libelle === "string" && libelle.trim() ? libelle.trim() : "Non classé";
        },

        /** Libellé avec dosage, unité et forme quand l'article (médicament) les porte dans son JSON d'attributs. */
        libelleArticle(article) {
            let attributs = {};
            if (article && article.attribut) {
                try {
                    attributs = typeof article.attribut === "string" ? JSON.parse(article.attribut) : article.attribut;
                } catch (e) {
                    attributs = {};
                }
            }
            attributs = attributs || {};
            const morceaux = [article.libelle, attributs.Dosage, attributs["Unité Dosage"], attributs.Forme]
                .filter((m) => m !== undefined && m !== null && String(m).trim() !== "");
            return morceaux.join(" ");
        },

        estDejaChoisi(article) {
            return this.articles.some((ligne) => Number(ligne.article) === Number(article.id));
        },

        choiceArticle(article) {
            if (Number(article.quantite) <= 0) return;
            if (!this.estDejaChoisi(article)) {
                if (this.articles.length >= 500) {
                    this.message_erreur = "Limite de 500 articles par dotation. Affinez le filtre ou faites une seconde dotation.";
                    return;
                }
                this.articles.push({
                    article: article.id,
                    libelle: this.libelleArticle(article),
                    disponible: Number(article.quantite) || 0,
                    nombre: null,
                });
            }
        },

        toggleArticle(article) {
            const index = this.articles.findIndex((ligne) => Number(ligne.article) === Number(article.id));
            if (index >= 0) this.deleteArticle(index);
            else {
                this.choiceArticle(article);
                this.appliquerAuxNouveauxArticles([article.id]);
            }
        },

        selectionnerVisibles() {
            const visibles = this.articles_selectionnables_visibles;
            if (this.tous_visibles_selectionnes) {
                const ids = new Set(visibles.map((article) => Number(article.id)));
                this.articles = this.articles.filter((ligne) => !ids.has(Number(ligne.article)));
            } else {
                const nouveaux = visibles.filter(article => !this.estDejaChoisi(article)).map(article => article.id);
                visibles.forEach((article) => this.choiceArticle(article));
                this.appliquerAuxNouveauxArticles(nouveaux);
            }
        },

        quantiteSaisie(article) {
            const ligne = this.articles.find((item) => Number(item.article) === Number(article.id));
            return ligne && ligne.nombre !== null ? ligne.nombre : "";
        },

        setQuantite(article, valeur) {
            const ligne = this.articles.find((item) => Number(item.article) === Number(article.id));
            if (ligne) ligne.nombre = valeur;
        },

        ligneEnErreur(article) {
            const ligne = this.articles.find((item) => Number(item.article) === Number(article.id));
            if (!ligne) return false;
            if (!this.validation_tentee && (ligne.nombre === null || ligne.nombre === "")) return false;
            const nombre = Number(ligne.nombre);
            return !Number.isInteger(nombre) || nombre <= 0 || nombre > ligne.disponible;
        },

        saisirQuantiteCommune(valeur) {
            this.quantite_commune = valeur;
            this.quantite_commune_erreur = "";
            this.quantite_commune_en_attente = valeur !== "";
            clearTimeout(this.quantite_commune_timer);
            this.quantite_commune_timer = valeur === "" ? null : setTimeout(() => this.appliquerQuantiteCommune(), 600);
        },

        appliquerAuxNouveauxArticles(ids) {
            const nombre = Number(this.quantite_commune);
            if (!Number.isInteger(nombre) || nombre <= 0 || this.quantite_commune_en_attente) return;
            this.preparerQuantiteCommune(this.articles.filter(ligne => ids.some(id => Number(id) === Number(ligne.article))));
        },

        appliquerQuantiteCommune() {
            clearTimeout(this.quantite_commune_timer);
            this.quantite_commune_timer = null;
            this.quantite_commune_en_attente = false;
            if (this.quantite_commune === "" || this.loading || this.stock_loading || this.confirmation_quantite) return;
            this.preparerQuantiteCommune(this.articles);
        },

        preparerQuantiteCommune(lignes) {
            this.quantite_commune_erreur = "";
            const nombre = Number(this.quantite_commune);
            if (!Number.isInteger(nombre) || nombre <= 0) {
                this.quantite_commune_erreur = "Saisissez un nombre entier supérieur à zéro.";
                return;
            }
            if (!lignes.length) return;
            const proposition = this.creerPropositionQuantite(lignes, nombre);
            if (proposition.lignes.some(ligne => ligne.proposee < nombre)) {
                this.proposition_quantite = proposition;
                this.confirmation_quantite_message = "";
                this.confirmation_quantite = true;
                return;
            }
            lignes.forEach(ligne => { ligne.nombre = nombre; });
        },

        creerPropositionQuantite(lignes, nombre) {
            return { nombre, lignes: lignes.map(ligne => {
                const disponible = Math.max(0, Math.floor(Number(ligne.disponible) || 0));
                return { article: ligne.article, libelle: ligne.libelle, disponible, proposee: Math.min(nombre, disponible) };
            }) };
        },

        validerQuantiteCommune() {
            if (!this.proposition_quantite || this.loading || this.stock_loading) return;
            const proposition = this.proposition_quantite;
            const lignes = this.articles.filter(ligne => proposition.lignes.some(item => Number(item.article) === Number(ligne.article)));
            const actuelle = this.creerPropositionQuantite(lignes, proposition.nombre);
            if (JSON.stringify(actuelle) !== JSON.stringify(proposition)) {
                this.proposition_quantite = actuelle;
                this.confirmation_quantite_message = "La sélection ou les disponibilités ont changé. Vérifiez les quantités avant de valider à nouveau.";
                return;
            }
            actuelle.lignes.forEach(item => {
                const ligne = this.articles.find(article => Number(article.article) === Number(item.article));
                ligne.nombre = item.proposee;
            });
            const epuises = actuelle.lignes.filter(item => item.proposee === 0).map(item => Number(item.article));
            this.articles = this.articles.filter(ligne => !epuises.includes(Number(ligne.article)));
            this.proposition_quantite = null;
            this.confirmation_quantite = false;
            this.quantite_commune_en_attente = false;
        },

        annulerQuantiteCommune() {
            clearTimeout(this.quantite_commune_timer);
            this.quantite_commune_timer = null;
            if (this.proposition_quantite) this.quantite_commune = "";
            this.proposition_quantite = null;
            this.confirmation_quantite = false;
            this.quantite_commune_en_attente = false;
        },

        deleteArticle(index) {
            this.articles.splice(index, 1);
        },

        /** Lignes envoyées au serveur : quantités entières. */
        lignesTransfert() {
            return this.articles.map((ligne) => ({ article: ligne.article, nombre: parseInt(ligne.nombre, 10) }));
        },

        /** Lignes dont la quantité est vide, nulle ou supérieure au disponible. */
        lignesInvalides() {
            return this.articles.filter((ligne) => {
                const nombre = Number(ligne.nombre);
                return !Number.isInteger(nombre) || nombre <= 0 || nombre > ligne.disponible;
            });
        },

        notifier(message, type) {
            if (!this.$toasted) return;
            this.$toasted.show(message, {
                duration: 4000,
                position: "top-center",
                type: type === "success" ? "success" : "error",
                theme: type === "success" ? "toasted-primary" : "toasted-danger",
                action: [{ text: "X", onClick: (e, toastObject) => { toastObject.goAway(0); } }],
            });
        },

        dispatchKey(fingerprint) {
            if (this.dispatch_fingerprint === fingerprint && this.dispatch_request_key) {
                return this.dispatch_request_key;
            }
            const storageKey = "clinicaa:service-dispatch:" + fingerprint;
            let key = null;
            try { key = sessionStorage.getItem(storageKey); } catch (e) { /* stockage indisponible */ }
            if (!key) {
                const bytes = new Uint8Array(16);
                window.crypto.getRandomValues(bytes);
                bytes[6] = (bytes[6] & 0x0f) | 0x40;
                bytes[8] = (bytes[8] & 0x3f) | 0x80;
                const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
                key = [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join("-");
                try { sessionStorage.setItem(storageKey, key); } catch (e) { /* idempotence conservée dans la page */ }
            }
            this.dispatch_fingerprint = fingerprint;
            this.dispatch_request_key = key;
            return key;
        },

        async submitForm() {
            if (this.loading || this.stock_loading || this.confirmation_quantite) return;
            if (this.quantite_commune_en_attente) this.appliquerQuantiteCommune();
            if (this.confirmation_quantite || this.quantite_commune_erreur) return;
            this.message_erreur = "";
            this.validation_tentee = true;
            if (!this.services_ready) {
                this.message_erreur = "Les services ne sont pas encore vérifiés. Réessayez.";
                return;
            }
            const isValid = await this.$refs.observer.validate();

            if (this.articles.length === 0) {
                this.message_erreur = "Sélectionnez au moins un article à transférer.";
                return;
            }
            if (!isValid || this.lignesInvalides().length > 0) {
                this.message_erreur = "Vérifiez les quantités : entre 1 et le disponible pour chaque ligne.";
                return;
            }

            this.loading = true;
            try {
                let response;
                if (this.destination_service) {
                    if (String(this.stock.code || "").toLowerCase() !== "pharmacie") {
                        this.message_erreur = "Une dotation de service doit partir de la Pharmacie centrale.";
                        return;
                    }
                    const items = this.lignesTransfert().map((line) => ({
                        article_id: Number(line.article), quantity: line.nombre,
                    })).sort((a, b) => a.article_id - b.article_id);
                    const fingerprint = JSON.stringify({ service_id: Number(this.destination_service.id), items });
                    response = await this.$store.dispatch("saveServiceDispatch", {
                        request_key: this.dispatchKey(fingerprint),
                        service_id: Number(this.destination_service.id), items,
                    });
                    if (!response || response.success !== true) throw new Error("Dotation non confirmée");
                    try { sessionStorage.removeItem("clinicaa:service-dispatch:" + fingerprint); } catch (e) { /* sans effet */ }
                    this.dispatch_fingerprint = null;
                    this.dispatch_request_key = null;
                } else {
                    response = await this.$store.dispatch("saveEchange", {
                        echanges: this.lignesTransfert(),
                        destination: this.destination_id,
                        depart: this.stock_id,
                    });
                }
                const refusees = response && response.erreur ? Number(response.erreur) : 0;
                if (refusees > 0) {
                    this.message_erreur = refusees + " ligne(s) non transférée(s) : quantité disponible insuffisante. Les autres lignes ont été transférées.";
                    this.notifier(this.message_erreur, "error");
                    this.articles = [];
                    await this.$store.dispatch("getStock", this.stock_id);
                } else {
                    this.notifier(this.destination_service ? "Dotation du service enregistrée." : "Transfert enregistré.", "success");
                    this.$router.push({ path: this.retour });
                }
            } catch (e) {
                this.message_erreur = (e.response && e.response.data && e.response.data.message) || "Le transfert n'a pas pu être enregistré.";
                this.notifier(this.message_erreur, "error");
                if (e.response && e.response.status === 409) await this.chargerStock();
            } finally {
                this.loading = false;
            }
        },
    },
};
